import { EventTypes } from "../../../../types";
import { getEventDetailsOutrightProps, getEventDetailsProps, getEventDetailsRaceProps, getEventDetailsAntePost } from "../../selection";
export const getEventDetailsSingleProps = (betType, selection, state) => {
    if (selection.eventType === EventTypes.Outright) {
        return getEventDetailsOutrightProps(betType, selection, state);
    }
    if (selection.eventType === EventTypes.DayOfEventRace) {
        return getEventDetailsRaceProps(betType, selection, state);
    }
    if (selection.eventType === EventTypes.AntePostRace) {
        return getEventDetailsAntePost(betType, selection, state);
    }
    return getEventDetailsProps(betType, selection, state);
};
//# sourceMappingURL=getEventDetailsSingleProps.js.map